exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1SgEp1U4PIR58Iv0wG1X4P{clear:both}.OpChn0T8Xp9CMcvqkx26X{display:inline-block}", ""]);
// Exports
exports.locals = {
	"clearBoth": "_1SgEp1U4PIR58Iv0wG1X4P",
	"loadingSpinner": "OpChn0T8Xp9CMcvqkx26X"
};